/* eslint-disable lingui/no-unlocalized-strings */
/* eslint-disable jsx-a11y/alt-text */
import { Helmet } from 'react-helmet';

export function GooglePixel({ authedUser: _ }: { authedUser?: boolean }) {
  // @ts-expect-error Mixing build styles in the same codebase
  const enabled = import.meta.env.PROD;
  // @ts-expect-error Mixing build styles in the same codebase
  const googlePixelId = import.meta.env.VITE_GOOGLE_PIXEL_ID;

  return (
    <>
      {enabled && (
        <Helmet>
          <script
            async
            src={`https://www.googletagmanager.com/gtag/js?id=${googlePixelId}`}
          ></script>
          <script>
            {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${googlePixelId}');
                `}
          </script>
        </Helmet>
      )}
    </>
  );
}
